"use client";
import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { SidebarLabel } from "../../atoms/sidebar";
import { Logo as CentiLogo } from "../../atoms/logo";
import { useStoreContext } from "@/lib/store";

export default function MenuLogo({ link = false }: { link?: boolean }) {
  const procure = "/procure";
  const pathname = usePathname();
  // const { theme } = useStoreContext();
  const theme = "light" as "light" | "dark";

  return pathname?.startsWith(procure) || pathname.endsWith("/") ? (
    <Link
      href="/procure"
      className="flex items-center space-x-0.5 !outline-none !ring-none focus-visible:outline-none">
      {theme === "dark" ? (
        <>
          <CentiLogo
            width={100}
            height={45}
            text="white"
            className="hidden md:inline-flex"
          />
          <CentiLogo
            width={90}
            height={45}
            text="white"
            className="md:hidden"
          />
        </>
      ) : (
        <>
          <CentiLogo
            width={100}
            height={45}
            className="hidden md:inline-flex"
          />
          <CentiLogo width={90} height={45} className="md:hidden" />
        </>
      )}
    </Link>
  ) : (
    <Link href="/hub" className="flex items-center space-x-0.5">
      {theme === "dark" ? (
        <>
          <CentiLogo
            width={100}
            height={45}
            className="hidden md:inline-flex"
          />
          <CentiLogo width={90} height={45} className="md:hidden" />
        </>
      ) : (
        <>
          <CentiLogo
            width={100}
            height={45}
            className="hidden md:inline-flex"
          />
          <CentiLogo width={80} height={45} className="md:hidden" />
        </>
      )}
      {/* <SidebarLabel className="text-sm">Hub</SidebarLabel> */}
    </Link>
  );
}
